export default __webpack_public_path__ + "static/media/habano-4Closed.09cdbdf2.jpg";